import { useEffect } from 'react';

export const useScrollIntoView = (ref: React.RefObject<HTMLDivElement | null>, shouldScroll: boolean) => {
    useEffect(() => {
        if (shouldScroll && ref?.current?.scrollIntoView) {
            ref.current.scrollIntoView({ block: 'end', inline: 'nearest', behavior: 'smooth' });
        }
    }, [ref, shouldScroll]);
};
